// Autentificare de test, pentru a parcurge fluxul local fara cont Google real
// si fara verificarea in doi pasi a ASE.
//
// - butoanele de login de test apar DOAR in development (npm start)
// - tokenurile "test:" nu sunt interpretate niciodata intr-un build de productie
// - serverul accepta tokenurile "test:" doar cand NODE_ENV === 'development'
//
// process.env.NODE_ENV este fixat la compilare de react-scripts:
// 'development' la `npm start`, 'test' sub teste, 'production' la `npm run build`.

// butoanele de login de test sunt vizibile doar in development
export const ESTE_DEV = process.env.NODE_ENV === 'development';

// tokenurile de test nu se interpreteaza niciodata in build-ul de productie
const PERMITE_TEST = process.env.NODE_ENV !== 'production';

// conturile de test; emailurile trebuie sa coincida cu server/seedDev.js
export const CONTURI_TEST = [
  { eticheta: 'Student test 1', email: 'stud.test1@stud.ase.ro', nume: 'Testov', prenume: 'Student' },
  { eticheta: 'Student test 2', email: 'stud.test2@stud.ase.ro', nume: 'Proba', prenume: 'Studenta' },
  { eticheta: 'Profesor test 1', email: 'prof.test1@csie.ase.ro', nume: 'Testescu', prenume: 'Profesor' },
  { eticheta: 'Profesor test 2', email: 'prof.test2@csie.ase.ro', nume: 'Probaru', prenume: 'Profesoara' },
];

// tokenul trimis in header-ul Authorization pentru un cont de test
export const tokenTest = ({ email, nume, prenume }) => `test:${email}:${nume}:${prenume}`;

// daca tokenul din localStorage este un token de test, intoarce datele lui;
// altfel null, iar tokenul se decodeaza ca JWT Google
export const dateToken = (token) => {
  if (PERMITE_TEST && token && token.startsWith('test:')) {
    const [, email] = token.split(':');
    return email ? { email, test: true } : null;
  }
  return null;
};
